module.exports = __webpack_public_path__ + "static/media/video2017.218dacb7.png";